import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  // plugins: [createPersistedState({
  //   storage: window.sessionStorage,
  // })],
  state: {
    cart : {
      items: [],
    },
    isAuthenticated: false,
    token: '',
    isLoading: false,
    wishboard_id_vue: '',
    username: '',
    gToken: '',
  },
  plugins: [createPersistedState()],
  getters: {
    getToken: (state) => {
        return state.token;
    },
    getUser: (state) => {
      return state.username;
    },
    getGToken: (state) => {
      return state.gToken;
    }
  },
  mutations: {
    initializeStore(state) {
      state.user_name = ''
      if (localStorage.getItem('token')) {
        state.isAuthenticated = true
      } else {
        state.token = ''
        state.isAuthenticated = false
      }

      if (localStorage.getItem('wishboard_id')) {
        state.wishboard_id_vue = localStorage.getItem('wishboard_id')
      }
    },
    
    setUser(state, user){
      state.username = user
    },
    
    setIsLoading(state, status){
      state.isLoading = status
    },
    setToken(state, token) {
      state.token = token
      state.isAuthenticated = true
    },
    setGToken(state, token) {
      state.gToken = token;
    },
    setWishboardId(state, wbid){
      state.wishboard_id_vue = wbid
    }


  },
  actions: {
  },
  modules: {
  }
})
